import { render, staticRenderFns } from "./FiltersClaims.vue?vue&type=template&id=8e73cf90"
import script from "./FiltersClaims.vue?vue&type=script&lang=js"
export * from "./FiltersClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports